<template>
    <div>
        <h1 class="About-FirstTitle" style="background-color:#A2CD5A;">小站改版信息 | Version</h1>
        <div class="About">
            <p class="About-ThirdTitle"><i class="fa fa-paint-brush" style="color:#1E90FF" title="微小改动"></i>&nbsp;:&nbsp;微小改动</p>
            <p class="About-ThirdTitle"><i class="fa fa-paint-brush" style="color:#32CD32" title="小改动"></i>&nbsp;:&nbsp;小改动</p>
            <p class="About-ThirdTitle"><i class="fa fa-paint-brush" style="color:#EE2C2C" title="重大改动"></i>&nbsp;:&nbsp;重大改动</p>
            <h2 class="About-SecondTitle" id="JSP_Servlet">JSP+Servlet版</h2>
            <p class="About-ThirdTitle"><b>2018年7月25日<i class="fa fa-paint-brush" style="color:#1E90FF" title="微小改动"></i></b></p>
            <span></span>
            <p class="About-Content">1.发布到学校内网，IP地址访问:192.168.31.116:8080/Netblog/Index.jsp</p>
            <p class="About-ThirdTitle"><b>2018年8月13日<i class="fa fa-paint-brush" style="color:#EE2C2C" title="重大改动"></i></b></p>
            <p class="About-Content">1.重构Servlet代码</p>
            <p class="About-ThirdTitle"><b>2018年8月15日<i class="fa fa-paint-brush" style="color:#32CD32" title="小改动"></i></b></p>
            <p class="About-Content">1.优化JSP页面代码，提高代码可读性</p>
            <p class="About-ThirdTitle"><b>2018年11月20日<i class="fa fa-paint-brush" style="color:#EE2C2C" title="重大改动"></i></b></p>
            <p class="About-Content">1.发布到公网，IP地址访问:47.107.229.62/Netblog/Index.jsp</p>
            <p class="About-ThirdTitle"><b>2019年1月21日<i class="fa fa-paint-brush" style="color:#EE2C2C" title="重大改动"></i></b></p>
            <p class="About-Content">1.发布到公网，域名访问:www.loveffc.cn</p>
            <p class="About-Content">2.增加移动端自适应</p>
            <p class="About-Content">3.进一步优化界面</p>
            <h2 class="About-SecondTitle" id="WordPress">WordPress版</h2>
            <p class="About-ThirdTitle"><b>2019年7月28日<i class="fa fa-paint-brush" style="color:#EE2C2C" title="重大改动"></i></b></p>
            <p class="About-Content">1.优化音乐播放功能，添加了固定效果。</p>
            <p class="About-Content">2.进一步优化界面的样式。</p>
            <p class="About-Content">3.去除了链接中的wordpress。</p>
            <p class="About-ThirdTitle"><b>2019年8月5日<i class="fa fa-paint-brush" style="color:#EE2C2C" title="重大改动"></i></b></p>
            <p class="About-Content">1.更换更适合的背景图片</p>
            <p class="About-Content">2.进一步优化界面的样式</p>
            <p class="About-Content">3.进一步优化文件结构</p>
            <p class="About-ThirdTitle"><b>2019年8月10日<i class="fa fa-paint-brush" style="color:#EE2C2C" title="重大改动"></i></b></p>
            <p class="About-Content">1.增加归档页面</p>
            <p class="About-Content">2.优化各页面的title标签</p>
            <p class="About-Content">3.进一步优化界面的样式</p>
            <p class="About-ThirdTitle"><b>2019年8月12日<i class="fa fa-paint-brush" style="color:#1E90FF" title="微小改动"></i></b></p>
            <p class="About-Content">1.合并编程目录与开源代码目录</p>
            <p class="About-Content">2.显示各个分类目录下属的文章篇数</p>
            <p class="About-Content">3.进一步优化界面的样式</p>
            <p class="About-ThirdTitle"><b>2019年8月17日<i class="fa fa-paint-brush" style="color:#32CD32" title="小改动"></i></b></p>
            <p class="About-Content">1.在原有pre标签基础上增加代码高亮</p>
            <p class="About-Content">2.进一步优化固定链接</p>
            <p class="About-Content">3.进一步优化界面的样式</p>
            <p class="About-ThirdTitle"><b>2019年8月18日<i class="fa fa-paint-brush" style="color:#1E90FF" title="微小改动"></i></b></p>
            <p class="About-Content">1.在原有pre标签基础上增加移动端代码滑动</p>
            <p class="About-Content">2.进一步优化界面的样式</p>
            <p class="About-ThirdTitle"><b>2019年8月27日<i class="fa fa-paint-brush" style="color:#1E90FF" title="微小改动"></i></b></p>
            <p class="About-Content">1.增加音乐播放/暂停更换图标的细节</p>
            <p class="About-ThirdTitle"><b>2019年8月29日<i class="fa fa-paint-brush" style="color:#32CD32" title="小改动"></i></b></p>
            <p class="About-Content">1.新增按分类归档和按标签归档页面</p>
            <p class="About-Content">2.进一步优化界面</p>
            <p class="About-ThirdTitle"><b>2019年9月15日<i class="fa fa-paint-brush" style="color:#1E90FF" title="微小改动"></i></b></p>
            <p class="About-Content">1.在代码高亮的基础上增加了显示行号</p>
            <p class="About-ThirdTitle"><b>2019年10月19日<i class="fa fa-paint-brush" style="color:#1E90FF" title="微小改动"></i></b></p>
            <p class="About-Content">1.优化PC端的代码显示样式</p>
            <p class="About-ThirdTitle"><b>2019年10月24日<i class="fa fa-paint-brush" style="color:#32CD32" title="小改动"></i></b></p>
            <p class="About-Content">1.增加文章页的上一篇、下一篇功能</p>
            <p class="About-ThirdTitle"><b>2019年11月1日<i class="fa fa-paint-brush" style="color:#EE2C2C" title="重大改动"></i></b></p>
            <p class="About-Content">1.对界面样式进行重大改动</p>
            <p class="About-Content">2.增加文章图片的预览显示</p>
            <p class="About-Content">3.增加邮件、GitHub、微信、QQ的添加功能</p>
            <p class="About-Content">4.优化多处样式</p>
            <p class="About-ThirdTitle"><b>2019年11月5日<i class="fa fa-paint-brush" style="color:#1E90FF" title="微小改动"></i></b></p>
            <p class="About-Content">1.更改ico图标</p>
            <p class="About-Content">2.进一步优化界面</p>
            <p class="About-ThirdTitle"><b>2019年11月11日<i class="fa fa-paint-brush" style="color:#1E90FF" title="微小改动"></i></b></p>
            <p class="About-Content">1.对邮件、Github、微信、QQ添加旋转效果</p>
            <p class="About-ThirdTitle"><b>2019年11月26日<i class="fa fa-paint-brush" style="color:#1E90FF" title="微小改动"></i></b></p>
            <p class="About-Content">1.对部分样式细节进行优化</p>
            <p class="About-ThirdTitle"><b>2019年12月2日<i class="fa fa-paint-brush" style="color:#32CD32" title="小改动"></i></b></p>
            <p class="About-Content">1.对文章页增加最近几篇文章的显示</p>
            <p class="About-Content">2.优化多处样式</p>
            <p class="About-ThirdTitle"><b>2020年1月5日<i class="fa fa-paint-brush" style="color:#EE2C2C" title="重大改动"></i></b></p>
            <p class="About-Content">1.对博客界面进行全新改版</p>
            <p class="About-Content">2.优化多处冗余代码</p>
            <p class="About-ThirdTitle"><b>2020年1月14日<i class="fa fa-paint-brush" style="color:#1E90FF" title="微小改动"></i></b></p>
            <p class="About-Content">1.对部分细节进行优化</p>
            <p class="About-ThirdTitle"><b>2020年1月19日<i class="fa fa-paint-brush" style="color:#1E90FF" title="微小改动"></i></b></p>
            <p class="About-Content">1.对部分细节进行优化</p>
            <p class="About-ThirdTitle"><b>2020年3月10日<i class="fa fa-paint-brush" style="color:#1E90FF" title="微小改动"></i></b></p>
            <p class="About-Content">1.对部分细节进行优化</p>
            <p class="About-ThirdTitle"><b>2020年4月1日<i class="fa fa-paint-brush" style="color:#1E90FF" title="微小改动"></i></b></p>
            <p class="About-Content">1.对部分细节进行优化</p>
            <p class="About-ThirdTitle"><b>2020年4月14日<i class="fa fa-paint-brush" style="color:#32CD32" title="小改动"></i></b></p>
            <p class="About-Content">1.对上一篇、下一篇文章的样式进行优化，修改为悬浮显示，更接近响应式布局</p>
            <p class="About-ThirdTitle"><b>2020年4月17日<i class="fa fa-paint-brush" style="color:#32CD32" title="小改动"></i></b></p>
            <p class="About-Content">1.恢复音乐播放功能</p>
            <p class="About-Content">2.对部分细节进行优化</p>
            <p class="About-ThirdTitle"><b>2020年4月26日<i class="fa fa-paint-brush" style="color:#1E90FF" title="微小改动"></i></b></p>
            <p class="About-Content">1.对部分细节进行优化</p>
            <p class="About-ThirdTitle"><b>2020年4月29日<i class="fa fa-paint-brush" style="color:#EE2C2C" title="重大改动"></i></b></p>
            <p class="About-Content">1.实现全站链接（除固定页面、标签、分类目录外）伪静态化</p>
            <p class="About-Content">2.实现Sitemap自动提交，增加360、搜狗、Bing的收录</p>
            <p class="About-Content">3.增加友情链接模块</p>
            <p class="About-Content">4.改变光标样式、滚动条样式</p>
            <p class="About-ThirdTitle"><b>2020年4月30日<i class="fa fa-paint-brush" style="color:#1E90FF" title="微小改动"></i></b></p>
            <p class="About-Content">1.对部分细节进行优化</p>
            <p class="About-ThirdTitle"><b>2020年8月10日<i class="fa fa-paint-brush" style="color:#1E90FF" title="微小改动"></i></b></p>
            <p class="About-Content">1.对部分细节进行优化</p>
            <p class="About-ThirdTitle"><b>2020年8月25日<i class="fa fa-paint-brush" style="color:#1E90FF" title="微小改动"></i></b></p>
            <p class="About-Content">1.对部分细节进行优化</p>
            <p class="About-ThirdTitle"><b>2020年8月30日<i class="fa fa-paint-brush" style="color:#1E90FF" title="微小改动"></i></b></p>
            <p class="About-Content">1.对分类、标签页的样式进行优化</p>
            <p class="About-ThirdTitle"><b>2020年10月13日<i class="fa fa-paint-brush" style="color:#EE2C2C" title="重大改动"></i></b></p>
            <p class="About-Content">1.引入Font Awesome，进一步优化图标样式</p>
            <p class="About-Content">2.优化导航栏、博客时间轴等栏目的样式</p>
            <p class="About-ThirdTitle"><b>2020年10月14日<i class="fa fa-paint-brush" style="color:#EE2C2C" title="重大改动"></i></b></p>
            <p class="About-Content">1.引入@font-face，进一步优化字体样式</p>
            <p class="About-Content">2.进一步优化导航栏、博客时间轴等栏目的样式</p>
            <p class="About-ThirdTitle"><b>2020年11月9日<i class="fa fa-paint-brush" style="color:#32CD32" title="小改动"></i></b></p>
            <p class="About-Content">1.对部分细节进行优化</p>
            <p class="About-Content">2.添加动态进度条，根据当前浏览的页面位置进行展示</p>
            <p class="About-ThirdTitle"><b>2020年11月15日<i class="fa fa-paint-brush" style="color:#1E90FF" title="微小改动"></i></b></p>
            <p class="About-Content">1.对部分细节进行优化</p>
            <p class="About-ThirdTitle"><b>2020年12月9日<i class="fa fa-paint-brush" style="color:#32CD32" title="小改动"></i></b></p>
            <p class="About-Content">1.变换“关于”页面的显示效果</p>
            <p class="About-ThirdTitle"><b>2020年12月24日<i class="fa fa-paint-brush" style="color:#32CD32" title="小改动"></i></b></p>
            <p class="About-Content">1.对部分细节进行优化</p>
            <p class="About-ThirdTitle"><b>2022年5月17日<i class="fa fa-paint-brush" style="color:#EE2C2C" title="重大改动"></i></b></p>
            <p class="About-Content">1.云服务器转为轻量应用服务器</p>
            <h2 class="About-SecondTitle" id="WordPress_Vue">WordPress+单页Vue.js版</h2>
            <p class="About-ThirdTitle"><b>2022年7月4日<i class="fa fa-paint-brush" style="color:#EE2C2C" title="重大改动"></i></b></p>
            <p class="About-Content">1.开始使用Vue对各个页面进行重写</p>
            <p class="About-ThirdTitle"><b>2022年7月25日<i class="fa fa-paint-brush" style="color:#32CD32" title="小改动"></i></b></p>
            <p class="About-Content">1.对图集页面的布局进行优化，使用div替换img</p>
            <p class="About-ThirdTitle"><b>2022年8月21日<i class="fa fa-paint-brush" style="color:#32CD32" title="小改动"></i></b></p>
            <p class="About-Content">1.对移动端的导航栏进行优化</p>
            <p class="About-Content">2.对关于页面进行优化</p>
            <h2 class="About-SecondTitle" id="Vue">多页Vue.js版</h2>
            <p class="About-ThirdTitle"><b>2022年8月28日<i class="fa fa-paint-brush" style="color:#EE2C2C" title="重大改动"></i></b></p>
            <p class="About-Content">1.开始使用多页Vue.js将各个页面使用组件模式进行重写</p>
          <p class="About-ThirdTitle"><b>2022年10月18日<i class="fa fa-paint-brush" style="color:#EE2C2C" title="重大改动"></i></b></p>
          <p class="About-Content">1.大部分页面重写过程中</p>
        </div>
      <div class="Slider">
        <p><a href="#JSP_Servlet">JSP+Servlet</a></p>
        <p><a href="#WordPress">WP</a></p>
        <p><a href="#WordPress_Vue">WP+Vue</a></p>
        <p><a href="#Vue">Vue</a></p>
      </div>
    </div>
</template>

<script>
export default {
    name: "TimeList"
}
</script>

<style src="../assets/StyleSheet/About.css" scoped>
</style>